module.exports = __webpack_public_path__ + "static/barbed-c6618e4b039a68cc0ffc951b72ef0601.png";